import { render, staticRenderFns } from "./base-menu-item.vue?vue&type=template&id=11034de0&scoped=true"
import script from "./base-menu-item.vue?vue&type=script&lang=ts"
export * from "./base-menu-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11034de0",
  null
  
)

export default component.exports